import { Store } from "../../reducers/store";

export const dispatchAction = (action) => {
    Store.dispatch(action);
};
